<script lang="ts">
  import Page from './Page.svelte';

  export let id: string;
</script>

<Page id="reader-page {id}">
  <slot />
</Page>

<style lang="scss">
  @import '../../styles/index';

  :global(.reader-page) {
    height: 100vh;
    display: flex;
    overflow: hidden;
  }
</style>
